import React, { Fragment } from 'react';
import { b2cPagesService } from '@clubmed/utils';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { Button } from 'Components/frameworks/button/Button';
import { Icon } from 'Components/frameworks/icon/Icon';
import { Text } from 'Components/frameworks/text/Text';
import { getRateMessagesProperties } from 'Components/widgets/rate-messages/RateMessages.utils';
import { usePageContext } from 'Context/PageContext';
export type ProductPriceInfoProps = {
  city: string;
  endDate: string;
  hasTransport?: boolean;
  isCruise?: boolean;
  isJoyview?: boolean;
  isTour?: boolean;
  onClick?: (e: React.SyntheticEvent<any>) => void;
  rate?: string;
  startDate: string;
  unit: string;
};
export const ProductPriceInfo = ({
  city,
  endDate,
  hasTransport,
  isCruise,
  isJoyview,
  isTour,
  onClick,
  rate = '',
  startDate,
  unit,
}: ProductPriceInfoProps) => {
  const { pageType } = usePageContext();
  const isMice = b2cPagesService.isMicePage(pageType);
  const isAllInclusive = !isJoyview && !isTour;
  // eslint-disable-next-line no-nested-ternary
  const buttonLabel = isTour
    ? t('resort.pricePopin.buttonTourLabel')
    : isCruise
      ? t('resort.pricePopin.buttonCruiseLabel')
      : t('resort.pricePopin.buttonLabel');
  const { rateContent, rateTitle } = getRateMessagesProperties(rate);
  // Display text only in product Thumbnails popin
  const rateObject = onClick
    ? {
        rateContent,
        rateTitle,
      }
    : {};
  return (
    <Fragment>
      <Text
        className="p-20"
        text={
          isMice
            ? t('resort.pricePopin.startingPriceDescriptionForME', {
                unit,
              })
            : [
                hasTransport
                  ? t('resort.pricePopin.startingPriceDescriptionWithTransport', {
                      unit,
                      city,
                      endDate,
                      startDate,
                    })
                  : t('resort.pricePopin.startingPriceDescriptionWithoutTransport', {
                      endDate,
                      startDate,
                      unit,
                    }),
                t('resort.pricePopin.roomAvailability'),
                rateObject?.rateTitle,
                rateObject?.rateContent,
              ].join(' ')
        }
        theme="text-sans-n2"
      />
      {(isAllInclusive || isJoyview || onClick) && (
        <div className="flex flex-col items-center border-t-1 border-lightGrey p-20">
          {isAllInclusive && (
            <p className="flex max-w-full flex-col gap-5 text-center text-12 text-black sm:flex-row sm:flex-wrap sm:items-center sm:justify-center">
              {t('resort.pricePopin.priceIsLabel')}{' '}
              <span className="flex items-center gap-5 font-brand text-16 text-sienna">
                <Icon className="text-sienna" name={ICONS.ALL_INCLUSIVE} width="1.2rem" />
                {t('resort.startingPrice.allInclusive')}
              </span>
            </p>
          )}
          {isJoyview && (
            <Icon
              className="-mt-5 text-blueWave"
              isNotSquare
              name={ICONS.CLUBMED_JOYVIEW}
              width="10rem"
            />
          )}
          {onClick && (
            <Button className="mt-10" data-testid="ProductPriceInfo-button" onClick={onClick}>
              {buttonLabel}
            </Button>
          )}
        </div>
      )}
    </Fragment>
  );
};
